import { useState } from 'react';

const INPUT_ID = 'date-input-enhancer-contract-date';
const HINT_ID = 'date-input-enhancer-contract-hint';

export const DateInputEnhancerContractPage = () => {
  const [value, setValue] = useState('');
  const [changeCount, setChangeCount] = useState(0);
  const [blurCount, setBlurCount] = useState(0);
  const [submitCount, setSubmitCount] = useState(0);
  const [submittedValue, setSubmittedValue] = useState('');
  const [invalidTargetId, setInvalidTargetId] = useState('');

  return (
    <section
      data-testid="date-input-enhancer-contract-root"
      className="mx-auto w-full max-w-3xl space-y-6 rounded-lg border border-border bg-white p-6 shadow-sm"
    >
      <header className="space-y-2">
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#237062]">
          Contract Harness
        </p>
        <h1 className="text-2xl font-semibold text-irongrey">
          Date Input Enhancer Contract
        </h1>
        <p className="max-w-2xl text-sm text-text-secondary">
          This surface proves the approved date-input contract: explicit opt-in,
          preserved label and described-by wiring, native validation, and owned
          blur/change/submit behavior.
        </p>
      </header>

      <form
        data-testid="date-input-enhancer-contract-form"
        className="space-y-4"
        onSubmit={(event) => {
          event.preventDefault();
          const form = event.currentTarget;
          if (!form.reportValidity()) {
            return;
          }
          const formData = new FormData(form);
          setSubmitCount((current) => current + 1);
          setSubmittedValue(String(formData.get('contractDate') ?? ''));
        }}
      >
        <div className="space-y-2">
          <label
            htmlFor={INPUT_ID}
            data-testid="date-input-enhancer-contract-label"
            className="block text-sm font-medium text-irongrey"
          >
            Contract date
          </label>
          <p
            id={HINT_ID}
            data-testid="date-input-enhancer-contract-hint"
            className="text-xs text-text-secondary"
          >
            Required. Allowed range: January 1, 2026 through December 31, 2026.
          </p>
          <input
            id={INPUT_ID}
            name="contractDate"
            type="date"
            required
            min="2026-01-01"
            max="2026-12-31"
            value={value}
            aria-describedby={HINT_ID}
            data-testid="date-input-enhancer-contract-input"
            data-ystnj-date-input-enhancer-opt-in="true"
            className="w-full rounded-md border border-border bg-white px-3 py-2 text-sm text-irongrey shadow-sm"
            onChange={(event) => {
              setValue(event.currentTarget.value);
              setChangeCount((current) => current + 1);
              setInvalidTargetId('');
            }}
            onBlur={() => {
              setBlurCount((current) => current + 1);
            }}
            onInvalid={(event) => {
              setInvalidTargetId(event.currentTarget.id);
            }}
          />
        </div>

        <div className="flex flex-wrap gap-3">
          <button
            type="submit"
            data-testid="date-input-enhancer-contract-submit"
            className="inline-flex items-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-white"
          >
            Submit
          </button>
        </div>
      </form>

      <dl className="grid gap-3 sm:grid-cols-2">
        <div className="rounded-md border border-border bg-muted/30 p-3">
          <dt className="text-xs font-semibold uppercase tracking-[0.14em] text-text-secondary">
            Change count
          </dt>
          <dd data-testid="date-input-enhancer-contract-change-count" className="mt-1 text-sm text-irongrey">
            {changeCount}
          </dd>
        </div>
        <div className="rounded-md border border-border bg-muted/30 p-3">
          <dt className="text-xs font-semibold uppercase tracking-[0.14em] text-text-secondary">
            Blur count
          </dt>
          <dd data-testid="date-input-enhancer-contract-blur-count" className="mt-1 text-sm text-irongrey">
            {blurCount}
          </dd>
        </div>
        <div className="rounded-md border border-border bg-muted/30 p-3">
          <dt className="text-xs font-semibold uppercase tracking-[0.14em] text-text-secondary">
            Submit count
          </dt>
          <dd data-testid="date-input-enhancer-contract-submit-count" className="mt-1 text-sm text-irongrey">
            {submitCount}
          </dd>
        </div>
        <div className="rounded-md border border-border bg-muted/30 p-3">
          <dt className="text-xs font-semibold uppercase tracking-[0.14em] text-text-secondary">
            Submitted value
          </dt>
          <dd data-testid="date-input-enhancer-contract-submitted-value" className="mt-1 text-sm text-irongrey">
            {submittedValue || 'none'}
          </dd>
        </div>
        <div className="rounded-md border border-border bg-muted/30 p-3 sm:col-span-2">
          <dt className="text-xs font-semibold uppercase tracking-[0.14em] text-text-secondary">
            Invalid target id
          </dt>
          <dd data-testid="date-input-enhancer-contract-invalid-target" className="mt-1 text-sm text-irongrey">
            {invalidTargetId || 'none'}
          </dd>
        </div>
      </dl>
    </section>
  );
};
